<template>
    <component :is="transformed" />
</template>

<script>
import { mapState } from 'vuex';
import Vue from 'vue';

const decode = require('unescape');
const moduleName = 'PageContent';

export default {
    name: moduleName,
    computed: {
        ...mapState(moduleName, {
            currentTemplate: state => state.currentTemplate,
            page: state => state.page,
            pagesScripts: state => state.pagesScirpts,
        }),
        transformed() {
            let me = this;
            if (this.currentTemplate === null) {
                return 'page-not-found';
            }
            if (typeof this.currentTemplate == 'string') {
                if (Vue.options.components[this.currentTemplate]) {
                    let config;
                    if (Vue.options.components[this.currentTemplate].options) {
                        config = {
                            ...Vue.options.components[this.currentTemplate].options,
                            created() {
                                this.$slots = me.$slots;
                            },
                            beforeUpdate() {
                                this.$slots = me.$slots;
                            },
                        };
                    } else {
                        config = {
                            ...Vue.options.components[this.currentTemplate],
                            created() {
                                this.$slots = me.$slots;
                            },
                            beforeUpdate() {
                                this.$slots = me.$slots;
                            },
                        };
                    }
                    delete config._Ctor;

                    return config;
                } else {
                    return {
                        template: decode(this.currentTemplate),
                        created() {
                            this.$slots = me.$slots;
                        },
                        beforeUpdate() {
                            this.$slots = me.$slots;
                        },
                    };
                }
            } else {
                return Vue.extend({
                    ...me.currentTemplate,
                    created() {
                        this.$slots = me.$slots;
                    },
                    beforeUpdate() {
                        this.$slots = me.$slots;
                    },
                });
            }
        },
        stylesheet() {
            return this.page && this.page.attributes && this.page.attributes.css_link
                ? this.page.attributes.css_link
                : null;
        },
        title() {
            return this.page && this.page.title ? this.page.title : '';
        },
        description() {
            return this.page && this.page.attributes && this.page.attributes.page_description
                ? this.page.attributes.page_description
                : '';
        },
    },
    mounted() {
        this.$store.watch(
            state => state.PageContent.pagesScripts,
            scripts => {
                if (scripts[this.currentTemplate]) {
                    this.$nextTick(() => {
                        addTemplateScript(this.currentTemplate, scripts[this.currentTemplate]);
                    });
                }
            },
            {
                deep: true,
                immediate: true,
            },
        );
    },
    metaInfo() {
        const meta = {};
        let links = [];
        if (this.stylesheet) {
            links.push({
                rel: 'stylesheet',
                href: this.stylesheet,
            });
        }
        meta.links = links;
        if (
            this.$router.currentRoute.meta.hasOwnProperty('metaInfoProvider') === false ||
            this.$router.currentRoute.meta.metaInfoProvider === false
        ) {
            meta.title = this.title;
            meta.meta = [
                {
                    vmid: 'description',
                    name: 'description',
                    content: this.description,
                },
            ];
            meta.__dangerouslyDisableSanitizersByTagID = {
                description: ['content'],
            };
        }
        return meta;
    },
};

const addTemplateScript = (pageName, scripts) => {
    const tagId = `${pageName}-scripts`;
    scripts.forEach((script, index) => {
        const scriptId = `${tagId}-${index}`;
        const oldScript = document.getElementById(scriptId);
        if (oldScript) {
            oldScript.remove();
        }
        const scriptEl = document.createElement('script');
        Object.keys(script).forEach(key => {
            scriptEl[key] = script[key];
        });
        scriptEl.id = scriptId;
        document.head.appendChild(scriptEl);
    });
};
</script>
